import React from 'react';
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image
} from '@react-pdf/renderer';
import logo from '../../../../Assets/Images/peicar.png';
import background from '../../../../Assets/Images/purchaseOrder/LogoMembretadoLite.png';

/* ────────────────────────────────────────────────────────────
   Reporte de Buró de Crédito — misma serigrafía / membretado
   que la Orden de Compra (PurchaseOrderPDF).
   Recibe el payload de GET /getReportBuro/{id}.
   ──────────────────────────────────────────────────────────── */

const GREEN = '#23b56e';
const CYAN = '#32b8df';
const SLATE = '#4a5568';

const styles = StyleSheet.create({
    page: {
        paddingTop: 30,
        paddingBottom: 45,
        paddingHorizontal: 30,
        fontSize: 8,
        fontFamily: 'Helvetica',
        color: '#333',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    logo: {
        width: 90,
    },
    titleSection: {
        marginTop: 12,
        textAlign: 'center',
    },
    mainTitle: {
        fontSize: 13,
        fontFamily: 'Helvetica-Bold',
        color: SLATE,
        textTransform: 'uppercase',
    },
    infoGraySection: {
        borderBottom: 1,
        borderBottomColor: SLATE,
        paddingBottom: 8,
        marginTop: 8,
        fontSize: 8,
        color: GREEN,
        lineHeight: 1.5,
        textAlign: 'center',
    },
    bold: { fontFamily: 'Helvetica-Bold' },
    section: {
        marginTop: 12,
    },
    sectionTitle: {
        fontSize: 10,
        fontFamily: 'Helvetica-Bold',
        backgroundColor: '#f7fafc',
        padding: 5,
        color: CYAN,
        borderLeft: 3,
        borderLeftColor: GREEN,
        marginBottom: 6,
    },
    /* Resumen */
    scoreBox: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 8,
        borderRadius: 4,
        borderLeft: 3,
        marginBottom: 6,
    },
    scoreLabel: { fontSize: 8, color: '#64748b' },
    scoreValue: { fontSize: 18, fontFamily: 'Helvetica-Bold' },
    scoreTag: { fontSize: 8, fontFamily: 'Helvetica-Bold' },
    cardsRow: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    metricCard: {
        width: '33.33%',
        padding: 3,
    },
    metricInner: {
        backgroundColor: '#F5F8FF',
        borderLeft: 3,
        borderLeftColor: CYAN,
        borderRadius: 3,
        padding: 5,
    },
    metricTitle: { fontSize: 7, color: '#64748b', marginBottom: 2 },
    metricValue: { fontSize: 9, fontFamily: 'Helvetica-Bold' },
    /* Tablas */
    tableTitle: {
        fontSize: 8,
        fontFamily: 'Helvetica-Bold',
        color: '#2d3748',
        textTransform: 'uppercase',
        letterSpacing: 0.4,
        marginTop: 8,
        marginBottom: 3,
    },
    tableHeaderRow: {
        flexDirection: 'row',
        backgroundColor: '#EDF6FB',
        borderBottom: 1,
        borderBottomColor: CYAN,
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 0.5,
        borderBottomColor: '#edf2f7',
    },
    th: {
        fontFamily: 'Helvetica-Bold',
        color: '#1565C0',
        paddingVertical: 3,
        paddingHorizontal: 2,
    },
    td: {
        paddingVertical: 3,
        paddingHorizontal: 2,
        color: '#2d3748',
    },
    emptyText: {
        fontSize: 7,
        color: '#94a3b8',
        fontStyle: 'italic',
        paddingVertical: 4,
    },
    /* Historial de pagos */
    accountBlock: {
        marginBottom: 8,
        borderWidth: 0.5,
        borderColor: '#e2e8f0',
        borderRadius: 3,
    },
    accountHeader: {
        backgroundColor: '#EDF6FB',
        paddingVertical: 4,
        paddingHorizontal: 5,
        borderBottomWidth: 0.5,
        borderBottomColor: '#cbd5e1',
    },
    accountName: {
        fontSize: 8,
        fontFamily: 'Helvetica-Bold',
        color: '#1565C0',
    },
    chipsRow: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        paddingHorizontal: 3,
        paddingTop: 4,
    },
    chip: {
        width: '25%',
        paddingHorizontal: 2,
        paddingBottom: 3,
    },
    chipLabel: { fontSize: 6, color: '#64748b' },
    chipValue: { fontSize: 7.5, fontFamily: 'Helvetica-Bold', color: '#2d3748' },
    monthHeaderRow: {
        flexDirection: 'row',
        backgroundColor: '#f8fafc',
        borderTopWidth: 0.5,
        borderTopColor: '#e2e8f0',
    },
    monthRow: {
        flexDirection: 'row',
        alignItems: 'center',
        borderTopWidth: 0.5,
        borderTopColor: '#f1f5f9',
    },
    yearCell: {
        width: '14%',
        fontSize: 7.5,
        fontFamily: 'Helvetica-Bold',
        color: '#2d3748',
        textAlign: 'center',
        paddingVertical: 2,
    },
    monthHeadCell: {
        width: '7.16%',
        fontSize: 6.5,
        fontFamily: 'Helvetica-Bold',
        color: '#64748b',
        textAlign: 'center',
        paddingVertical: 2,
    },
    monthCell: {
        width: '7.16%',
        alignItems: 'center',
        paddingVertical: 1.5,
    },
    badge: {
        width: 11,
        height: 11,
        borderRadius: 6,
        alignItems: 'center',
        justifyContent: 'center',
    },
    badgeText: { fontSize: 6, color: '#fff', fontFamily: 'Helvetica-Bold' },
    badgeEmpty: { fontSize: 6.5, color: '#cbd5e1' },
    /* Pie */
    footer: {
        position: 'absolute',
        bottom: 18,
        left: 30,
        right: 30,
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderTopWidth: 0.5,
        borderTopColor: '#cbd5e1',
        paddingTop: 5,
        fontSize: 6.5,
        color: '#718096',
    },
    backgroundImage: {
        position: 'absolute',
        left: 0,
        bottom: 0,
        right: 0,
        width: '100vw',
        height: 'auto',
        zIndex: -1,
    },
});

const MONTH_CODES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const MONTH_LETTERS = ['E', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];

// ─── Helpers ─────────────────────────────────────────────
const safe = (v) => {
    if (v === null || v === undefined) return '-';
    if (typeof v === 'object') return safe(v.name ?? v.value ?? '');
    const s = String(v).trim();
    return s === '' ? '-' : s;
};

// Arriba de este número de columnas una tabla es ilegible en A4 vertical:
// se renderiza como fichas (un bloque por registro) en vez de renglones.
const MAX_TABLE_COLUMNS = 10;

const fontForColumns = (n) => {
    if (n <= 4) return 8;
    if (n <= 6) return 7.2;
    if (n <= 8) return 6.6;
    return 6;
};

// El backend repite columnas en algunas tablas (p. ej. Cuentas manda
// 29 columnas de las que 7 están duplicadas). Nos quedamos con la primera.
const dedupeColumns = (columns = []) => {
    const seen = new Set();
    return columns.filter((col) => {
        const field = (col?.field || '').trim();
        if (!field) return true;
        if (seen.has(field)) return false;
        seen.add(field);
        return true;
    });
};

// Ancho por columna proporcional al contenido real, no a partes iguales:
// "Nombre Otorgante" necesita mucho más que "Días Vencidos".
const computeWidths = (columns, rows) => {
    const sample = rows.slice(0, 80);
    const weights = columns.map((col) => {
        const field = (col?.field || '').trim();
        // el encabezado se envuelve en 2-3 renglones, pesa menos que el dato
        let longest = String(col?.header || '').length / 1.8;
        sample.forEach((row) => {
            const value = safe(row?.[field]);
            if (value !== '-') longest = Math.max(longest, value.length);
        });
        return Math.min(Math.max(longest, 4), 20);
    });
    const total = weights.reduce((a, b) => a + b, 0) || 1;
    return weights.map((w) => `${((w / total) * 100).toFixed(3)}%`);
};

// Vista compacta de una tabla ancha: sólo las columnas clave.
const subsetTable = (table, fields, name) => {
    if (!table) return null;
    const columns = dedupeColumns(table.configuration || [])
        .filter((col) => fields.includes((col?.field || '').trim()))
        .sort(
            (a, b) =>
                fields.indexOf((a.field || '').trim()) -
                fields.indexOf((b.field || '').trim())
        );
    if (columns.length === 0) return null;
    return { name, configuration: columns, data: table.data || [] };
};

// '$4,737+' -> 4737 ; '' -> 0
const toNumber = (v) => {
    const n = Number(String(v ?? '').replace(/[^0-9.-]/g, ''));
    return Number.isFinite(n) ? n : 0;
};

// El detalle largo (una ficha por credito) solo tiene sentido para las cuentas
// vivas. Un buro con 196 cuentas genera ~4,000 vistas y tumba el navegador;
// el resumen de arriba sigue listando TODAS.
const ACTIVE_FIELDS = ['saldo_actual', 'saldo_vencido', 'dias_vencidos', 'numero_pagos_vencidos'];
const activeAccountsTable = (table, name) => {
    if (!table) return null;
    const rows = (table.data || []).filter((row) =>
        ACTIVE_FIELDS.some((f) => toNumber(row?.[f]) > 0)
    );
    if (rows.length === 0) return null;
    return { ...table, name, data: rows };
};

const SUMMARY_COLUMNS = {
    cuentas: [
        'nombre_otorgante',
        'tipo_contrato',
        'fecha_apertura_cuenta',
        'monto_pagar',
        'saldo_actual',
        'saldo_vencido',
        'limite_credito',
        'dias_vencidos',
    ],
};

const badgeColor = (value) => {
    const num = Number(value);
    if (num === 1) return '#22c55e';
    if (num === 2) return '#f59e0b';
    if (num >= 3 && num <= 5) return '#f97316';
    if (num >= 6) return '#ef4444';
    return '#94a3b8';
};

const scorePalette = (score, threshold) => {
    const n = Number(score);
    if (score == null || score === '' || Number.isNaN(n)) return { bg: '#f1f5f9', color: '#64748b', label: 'Sin dato' };
    if (n >= threshold) return { bg: '#dcfce7', color: '#16a34a', label: 'Bueno' };
    if (n >= threshold * 0.7) return { bg: '#fef3c7', color: '#d97706', label: 'Regular' };
    return { bg: '#fee2e2', color: '#dc2626', label: 'Bajo' };
};

// Aplana [[...]] -> [...] (algunos bloques vienen envueltos en un arreglo extra)
const flattenHistory = (raw) => {
    if (!Array.isArray(raw)) return [];
    if (raw.length && Array.isArray(raw[0])) return raw.flat();
    return raw;
};

// ─── Fichas: un bloque por registro (tablas muy anchas) ───
const RecordCards = ({ table, columns }) => {
    const rows = table.data || [];
    if (rows.length === 0) return <Text style={styles.emptyText}>Sin registros.</Text>;

    const [titleCol, ...detailCols] = columns;
    const titleField = (titleCol?.field || '').trim();

    return <>{rows.map((row, ri) => {
        const title = safe(row?.[titleField]);
        return (
            <View key={ri} style={styles.accountBlock} wrap={false}>
                <View style={styles.accountHeader}>
                    <Text style={styles.accountName}>
                        {`${ri + 1}. ${title !== '-' ? title : `Registro ${ri + 1}`}`}
                        {title !== '-' ? `  ·  ${titleCol?.header || ''}` : ''}
                    </Text>
                </View>
                <View style={styles.chipsRow}>
                    {detailCols.map((col, ci) => (
                        <View key={ci} style={styles.chip}>
                            <Text style={styles.chipLabel}>{col.header}</Text>
                            <Text style={styles.chipValue}>
                                {safe(row?.[(col.field || '').trim()])}
                            </Text>
                        </View>
                    ))}
                </View>
            </View>
        );
    })}</>;
};

// ─── Tabla genérica {name, configuration, data} ───────────
const DataTable = ({ table }) => {
    if (!table) return null;
    const columns = dedupeColumns(table.configuration || []);
    const rows = table.data || [];
    if (columns.length === 0) return null;

    // Demasiadas columnas para un renglón legible → fichas por registro.
    if (columns.length > MAX_TABLE_COLUMNS) {
        return (
            <View style={{ marginBottom: 4 }}>
                <Text style={styles.tableTitle} minPresenceAhead={40}>
                    {table.name || ''}
                </Text>
                <RecordCards table={table} columns={columns} />
            </View>
        );
    }

    const fs = fontForColumns(columns.length);
    const widths = computeWidths(columns, rows);

    return (
        <View style={{ marginBottom: 4 }}>
            <View minPresenceAhead={40}>
                <Text style={styles.tableTitle}>{table.name || ''}</Text>
                <View style={styles.tableHeaderRow}>
                    {columns.map((col, i) => (
                        <Text key={i} style={[styles.th, { width: widths[i], fontSize: fs }]}>
                            {col.header}
                        </Text>
                    ))}
                </View>
            </View>
            {rows.length === 0 ? (
                <Text style={styles.emptyText}>Sin registros.</Text>
            ) : (
                rows.map((row, ri) => (
                    <View
                        key={ri}
                        style={[styles.tableRow, ri % 2 === 1 ? { backgroundColor: '#FAFCFE' } : {}]}
                        wrap={false}
                    >
                        {columns.map((col, ci) => (
                            <Text key={ci} style={[styles.td, { width: widths[ci], fontSize: fs }]}>
                                {safe(row?.[(col.field || '').trim()])}
                            </Text>
                        ))}
                    </View>
                ))
            )}
        </View>
    );
};

// ─── Historial de pagos (PF y PM comparten estructura) ────
const PaymentHistory = ({ title, items, variant }) => {
    const lines = flattenHistory(items);
    if (!lines.length) return null;

    return (
        <View style={{ marginBottom: 4 }}>
            <Text style={styles.tableTitle} minPresenceAhead={40}>{title}</Text>
            {lines.map((line, idx) => {
                const years = line?.representative?.data || [];
                const chips = [
                    [line?.campo || 'Monto a pagar', line?.valor],
                    [line?.campo2 || 'Límite de crédito', line?.valor2],
                    [line?.campo3 || 'Saldo actual', line?.valor3],
                    [line?.campo4 || 'Crédito máximo', line?.valor4],
                    [line?.campo5 || 'Apertura', line?.valor5],
                    [line?.campo6 || 'Fecha último pago', line?.valor6],
                    [line?.campo7 || 'Saldo vencido', line?.valor7],
                    [line?.campo8 || 'Monto último pago', line?.valor8],
                ];
                if (variant === 'liquidado') {
                    chips.push(['Quita', line?.quita], ['Dación', line?.dacion], ['Quebranto', line?.quebranto]);
                }
                if (variant === 'activo') {
                    chips.push(
                        ['1-29 días', line?.saldo_vencido_de_1a29_dias],
                        ['30-59 días', line?.saldo_vencido_de_30a59_dias],
                        ['60-89 días', line?.saldo_vencido_de_60a89_dias],
                        ['90-119 días', line?.saldo_vencido_de_90a119_dias],
                        ['120-179 días', line?.saldo_vencido_de_120a179_dias],
                        ['180+ días', line?.saldo_vencido_de_180_dias_o_mas],
                    );
                }

                return (
                    <View key={line?.id ?? idx} style={styles.accountBlock} wrap={false}>
                        <View style={styles.accountHeader}>
                            <Text style={styles.accountName}>
                                {safe(line?.representative?.name || line?.name)}
                            </Text>
                        </View>

                        <View style={styles.chipsRow}>
                            {chips.map(([label, value], ci) => (
                                <View key={ci} style={styles.chip}>
                                    <Text style={styles.chipLabel}>{label}</Text>
                                    <Text style={styles.chipValue}>{safe(value)}</Text>
                                </View>
                            ))}
                        </View>

                        {years.length > 0 && (
                            <>
                                <View style={styles.monthHeaderRow}>
                                    <Text style={styles.yearCell}>Año</Text>
                                    {MONTH_LETTERS.map((m, i) => (
                                        <Text key={i} style={styles.monthHeadCell}>{m}</Text>
                                    ))}
                                </View>
                                {years.map((yearRow, yi) => (
                                    <View key={yi} style={styles.monthRow}>
                                        <Text style={styles.yearCell}>{safe(yearRow?.anio)}</Text>
                                        {MONTH_CODES.map((code, mi) => {
                                            const value = yearRow?.[code];
                                            const empty = value === undefined || value === null || String(value).trim() === '';
                                            return (
                                                <View key={mi} style={styles.monthCell}>
                                                    {empty ? (
                                                        <Text style={styles.badgeEmpty}>-</Text>
                                                    ) : (
                                                        <View style={[styles.badge, { backgroundColor: badgeColor(value) }]}>
                                                            <Text style={styles.badgeText}>{String(value)}</Text>
                                                        </View>
                                                    )}
                                                </View>
                                            );
                                        })}
                                    </View>
                                ))}
                            </>
                        )}
                    </View>
                );
            })}
        </View>
    );
};

const MetricCard = ({ title, value, color = CYAN }) => (
    <View style={styles.metricCard}>
        <View style={[styles.metricInner, { borderLeftColor: color }]}>
            <Text style={styles.metricTitle}>{title}</Text>
            <Text style={[styles.metricValue, { color }]}>{safe(value)}</Text>
        </View>
    </View>
);

// ─── Cascaron de pagina (membrete + pie) ─────────────────
// react-pdf pagina CADA <Page> por separado y relayoutea todo lo que queda
// en cada corte: con un solo <Page> de 70 hojas el costo es cuadratico.
// Partir el reporte en bloques baja el tiempo de render varias veces.
const ReportPage = ({ children }) => (
    <Page size="A4" style={styles.page}>
        <Image src={background} style={styles.backgroundImage} fixed />
        {children}
        <View style={styles.footer} fixed>
            <Text>
                Información confidencial obtenida de Buró de Crédito. Uso exclusivo para análisis crediticio de PEICAR / Conduce Capital S.A.P.I. de C.V.
            </Text>
            <Text render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} />
        </View>
    </Page>
);

const TableBlock = ({ title, tables }) => {
    const list = (tables || []).filter(Boolean);
    if (list.length === 0) return null;
    return (
        <View style={styles.section}>
            <Text style={styles.sectionTitle} minPresenceAhead={60}>{title}</Text>
            {list.map((table, i) => <DataTable key={i} table={table} />)}
        </View>
    );
};

// ─── Documento ───────────────────────────────────────────
const BuroCreditoPDF = ({ data, persona, date }) => {
    const isPM = data?.tipo_persona === 'PM';
    const cards = data?.cards || {};
    const meta = data?.reporte || {};
    const threshold = isPM ? 200 : 600;
    const score = scorePalette(cards.score, threshold);

    const cliente = persona?.name_syntage || persona?.name || 'Cliente';
    const gestion = persona?.id ? `Gestión #${persona.id}` : '';
    const rfc = data?.nombresClientes?.data?.[0]?.rfc
        || data?.datosGenerales?.data?.[0]?.rfc
        || persona?.rfc
        || '-';
    const fechaConsulta = meta.fecha_generacion
        || (date ? new Date(date) : new Date()).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
    const emitido = (date ? new Date(date) : new Date()).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });

    const totalCuentas = data?.cuentas?.data?.length || 0;
    const cuentasResumen = subsetTable(
        data?.cuentas,
        SUMMARY_COLUMNS.cuentas,
        `Cuentas — resumen (${totalCuentas} ${totalCuentas === 1 ? 'crédito' : 'créditos'})`
    );
    const cuentasDetalle = activeAccountsTable(
        data?.cuentas,
        'Cuentas — detalle por crédito (solo cuentas con saldo o vencidas)'
    );

    // Bloques: cada uno se pagina por separado
    const blocks = isPM
        ? [
            { title: '2. IDENTIFICACIÓN DE LA EMPRESA', tables: [data?.datosGenerales, data?.accionistas] },
            { title: '3. CRÉDITOS Y CALIFICACIONES', tables: [data?.historiaFinanciera, data?.calificaciones] },
            { title: '4. CONSULTAS Y ALERTAS', tables: [data?.historialConsultas, data?.hawkHr, data?.hawkHc, data?.hawkAlertBd] },
        ]
        : [
            { title: '2. IDENTIFICACIÓN DEL CLIENTE', tables: [data?.nombresClientes, data?.domicilios, data?.empleos] },
            { title: '3. CUENTAS', tables: [cuentasResumen, cuentasDetalle] },
            { title: '4. CONSULTAS Y ALERTAS', tables: [data?.consultasEfectuadas, data?.hawkAlertConsultas, data?.hawkAlertBd, data?.declaracionesCliente] },
        ];

    const historyBlocks = isPM
        ? [
            { title: 'Historial de pagos financiero — Activo', items: data?.historialPagosFinancierosNoLiquidados, variant: 'activo' },
            { title: 'Historial de pagos financiero — Liquidado', items: data?.historialPagosFinancierosLiquidados, variant: 'liquidado' },
            { title: 'Historial de pagos comercial', items: data?.historialPagosComercial },
        ].filter((b) => flattenHistory(b.items).length > 0)
        : [
            { title: 'Historial de pagos', items: data?.historialPagos },
        ].filter((b) => flattenHistory(b.items).length > 0);

    return (
        <Document
            title={`Buro de credito - ${cliente}`}
            author="PEICAR / Conduce Capital S.A.P.I. de C.V."
        >
            {/* Portada + resumen */}
            <ReportPage>
                <View style={styles.header}>
                    <Image src={logo} style={styles.logo} />
                </View>

                <View style={styles.titleSection}>
                    <Text style={styles.mainTitle}>
                        Reporte de Buró de Crédito {isPM ? '(Persona Moral)' : '(Persona Física)'}
                    </Text>
                </View>

                <View style={styles.infoGraySection}>
                    <Text>
                        <Text style={styles.bold}>Cliente:</Text> {cliente}
                        {gestion ? ` | ${gestion}` : ''} | <Text style={styles.bold}>RFC:</Text> {rfc}
                    </Text>
                    <Text>
                        <Text style={styles.bold}>Consulta:</Text> {fechaConsulta}
                        {meta.numero_control_consulta ? ` | Folio: ${meta.numero_control_consulta}` : ''}
                        {meta.codigo_reporte ? ` | Reporte: ${meta.codigo_reporte}` : ''}
                        {` | `}<Text style={styles.bold}>Emitido:</Text> {emitido}
                    </Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.sectionTitle}>1. RESUMEN DE CRÉDITO</Text>

                    <View style={[styles.scoreBox, { backgroundColor: score.bg, borderLeftColor: score.color }]}>
                        <View>
                            <Text style={styles.scoreLabel}>Score de Crédito</Text>
                            <Text style={[styles.scoreValue, { color: score.color }]}>{safe(cards.score)}</Text>
                        </View>
                        <Text style={[styles.scoreTag, { color: score.color }]}>{score.label}</Text>
                    </View>

                    <View style={styles.cardsRow}>
                        {isPM ? (
                            <>
                                <MetricCard title="Créditos financieros" value={cards.totalCreditosFinancieros} />
                                <MetricCard title="Créditos comerciales" value={cards.totalCreditosComerciales} />
                                <MetricCard title="Saldo quita y quebranto" value={cards.saldoAcumuladoQuitaQuebranto != null ? `$${cards.saldoAcumuladoQuitaQuebranto}` : null} color="#E65100" />
                                <MetricCard title="Créditos quita/quebranto" value={cards.ratioQuitaQuebranto} color="#E65100" />
                                <MetricCard title="Saldo total financiero" value={cards.saldoTotalFinanciero != null ? `$${cards.saldoTotalFinanciero}` : null} color={GREEN} />
                                <MetricCard title="Saldo total comercial" value={cards.saldoTotalComercial != null ? `$${cards.saldoTotalComercial}` : null} color={GREEN} />
                            </>
                        ) : (
                            <>
                                <MetricCard title="Obligaciones" value={cards.obligaciones != null ? `$${cards.obligaciones}` : null} color="#34b9e0" />
                                <MetricCard title="Límite tarjetas de crédito" value={cards.limiteTarjetas != null ? `$${cards.limiteTarjetas}` : null} />
                                <MetricCard title="Suma saldos actuales" value={cards.sumaSaldoActual != null ? `$${cards.sumaSaldoActual}` : null} />
                                <MetricCard title="Total de tarjetas" value={cards.totalTarjetas} />
                                <MetricCard title="Cuentas abiertas" value={cards.cuentasAbiertas} color={GREEN} />
                                <MetricCard
                                    title="Cuentas con saldo vencido"
                                    value={cards.cuentasConSaldoVencido}
                                    color={String(cards.cuentasConSaldoVencido || '').startsWith('0 ') ? GREEN : '#dc2626'}
                                />
                            </>
                        )}
                    </View>
                </View>
            </ReportPage>

            {/* Un <Page> por bloque */}
            {blocks.map((block, i) => (
                <ReportPage key={i}>
                    <TableBlock title={block.title} tables={block.tables} />
                </ReportPage>
            ))}

            {/* Historial de pagos: un <Page> por historial */}
            {historyBlocks.map((block, i) => (
                <ReportPage key={`h${i}`}>
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle} minPresenceAhead={60}>
                            {historyBlocks.length > 1 ? `5.${i + 1}` : '5.'} {block.title.toUpperCase()}
                        </Text>
                        <PaymentHistory title={block.title} items={block.items} variant={block.variant} />
                        <Text style={{ fontSize: 6.5, color: '#718096', marginTop: 4 }}>
                            Claves de comportamiento: 1 = pago puntual · 2 a 5 = atraso creciente · 6 o más = mora severa · «-» sin información.
                        </Text>
                    </View>
                </ReportPage>
            ))}
        </Document>
    );
};

export default BuroCreditoPDF;
